import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

class ExampleComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      toggled: false,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.setState({
      toggled: !this.state.toggled,
    })
  }

  render() {
    return (
      <div
        className={
          'dhsv_example_component' +
          (this.state.toggled ? ' toggled' : '') +
          (this.props.isMobile ? ' mobile' : '')
        }
        onClick={this.handleClick}
      >
        <span>dies ist eine React-Komponente</span>
      </div>
    )
  }
}

ExampleComponent.propTypes = {
  isMobile: PropTypes.bool,
}

export default ExampleComponent
